export default

    class FeedbackController {

    constructor(resource) {
        this._resource = resource
    }

    async post(form, idVehicle){
        
        this._resource("feed-back").save({
            vehicle_request_id: idVehicle,
            form_date: form
        })
    }

    async getFeedbackReport() {
        let response = await this._resource(`feed-back`).get();
  
        return response.json()
      }
 
    async getByVehicleRequestId(_id) {
        
        let response = await this._resource(`feed-back/${_id}`).get();
        
        return response.json();
    }
}